import React from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Switch,
} from "react-router-dom";
import SHSRExaminations from "../pages/SHSR/examinations";
import SREEIndustryInteraction from "../pages/SREE/industry-interaction";
import SREEPlacements from "../pages/SREE/placements";

import Error from "../pages/404";
import LoadTop from "../components/Common/ScrollTop/LoadTop";
import EnvironmentalOccupationalHealthSafety from "../pages/SHSR/EnvironmentalOccupationalHealthSafety";
import HealthConference from "../pages/SHSR/HealthConference";
import CommonHome from "../pages/common pages/home";
import CommonGallery from "../pages/common pages/gallery";
import CommonContact from "../pages/common pages/contact";
import CommonAbout from "../pages/common pages/about";
import CommonInfrastructure from "../pages/common pages/infrastructure";
import CommonFaculty from "../pages/common pages/faculty";
import SOAGallery from "../pages/SOA/gallery";
import CommonAboutCourse from "../pages/common pages/about-course";
import CommonEligibility from "../pages/common pages/eligibility";
import CommonSyllabus from "../pages/common pages/syllabus";
import CommonBOS from "../pages/common pages/bos";
import CommonResearchPublications from "../pages/common pages/research-publications";
import CampusPlacements from "../pages/SOA/campus-placements";
import MousSigned from "../pages/SOA/mous signed";
import InternshipOpportunities from "../pages/SOA/internship-opportunities";
import CommonCourseStructure from "../pages/common pages/course-structure";
import VisionAndMission from "../pages/SSIT/vision and mission";
import AcademicCalendar from "../pages/SSIT/academic calendar";
import Timetables from "../pages/SSIT/timetables";
import CaseStudyFocus from "../pages/SSIT/case study focus";
import SSITAdvantage from "../pages/SSIT/SSIT Advantage";
import ResearchScholars from "../pages/SSIT/research scholars";
import ResearchPublications from "../pages/SSIT/research publications";
import AcademicCalenders from "../pages/SNT/academic calenders";
import SNTTimetables from "../pages/SNT/timetables";
import IndustryInteraction from "../pages/SNT/industry interaction";
import ProjectOpportunities from "../pages/SNT/project opportunities";
import NotificationsTenders from "../pages/SNT/notifications and tenders";
import SportsActivity from "../pages/SNT/sports activity";
import SNTAchievements from "../pages/SNT/achievements";
import StudentActivities from "../pages/SNT/student activities";
import Programs from "../pages/SMS/Programs";
import SMSNotifications from "../pages/SMS/notifications";
import SMSPlacements from "../pages/SMS/placements";
import SMSAchivements from "../pages/SMS/achivements";
import Alumni from "../pages/SMS/gallery";
import ForthcomingEvents from "../pages/SMS/Forthcoming Events";
import PastEvents from "../pages/SMS/Past Events";
import SNTCampusPlacements from "../pages/SNT/campus placements";
import Profile from "../pages/common pages/profile";
import WorkshopConference from "../pages/SSIT/workshop and conference";
import Downloads from "../pages/SSIT/downloads";
import SSITGallery from "../pages/SSIT/gallery";

const App = () => {
  const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
  console.log("testing88.......", currentDomain, window.location.hostname);

  return (
    <div className="App">
      <Router>
        <LoadTop />
        {getRoutes(currentDomain)}
      </Router>
    </div>
  );
};
const getRoutes = (currentDomain) => {
  if (currentDomain === "shsr")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route
          path={`/${currentDomain}/examinations`}
          component={SHSRExaminations}
        />
        <Route path={`/${currentDomain}/faculty`} component={CommonFaculty} />
        <Route
          path={`/${currentDomain}/health-conference`}
          component={HealthConference}
        />
        <Route
          path={`/${currentDomain}/environmental-occupational-health-safety`}
          component={EnvironmentalOccupationalHealthSafety}
        />
        <Route path={`/${currentDomain}/gallery`} component={CommonGallery} />
        <Route
          path={`/${currentDomain}/contact-us`}
          component={CommonContact}
        />
        <Route path={`/${currentDomain}/about-us`} component={CommonAbout} />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );

  if (currentDomain === "sree")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route
          path={`/${currentDomain}/course-structure`}
          component={CommonCourseStructure}
        />
        <Route
          path={`/${currentDomain}/about-course`}
          component={CommonAboutCourse}
        />
        <Route
          path={`/${currentDomain}/infra-structure`}
          component={CommonInfrastructure}
        />
        <Route path={`/${currentDomain}/syllabus`} component={CommonSyllabus} />
        <Route path={`/${currentDomain}/faculty`} component={CommonFaculty} />
        <Route
          path={`/${currentDomain}/research-publications`}
          component={CommonResearchPublications}
        />
        <Route
          path={`/${currentDomain}/university-industry-interaction`}
          component={SREEIndustryInteraction}
        />
        <Route
          path={`/${currentDomain}/placements`}
          component={SREEPlacements}
        />
        <Route path={`/${currentDomain}/gallery`} component={CommonGallery} />
        <Route
          path={`/${currentDomain}/eligibility`}
          component={CommonEligibility}
        />
        <Route
          path={`/${currentDomain}/contact-us`}
          component={CommonContact}
        />
        <Route path={`/${currentDomain}/about-us`} component={CommonAbout} />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );

  if (currentDomain === "soa")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route
          path={`/${currentDomain}/about-course`}
          component={CommonAboutCourse}
        />
        <Route path={`/${currentDomain}/gallery`} component={SOAGallery} />
        <Route
          path={`/${currentDomain}/infra-structure`}
          component={CommonInfrastructure}
        />
        <Route path={`/${currentDomain}/syllabus`} component={CommonSyllabus} />
        <Route path={`/${currentDomain}/faculty`} component={CommonFaculty} />
        <Route path={`/${currentDomain}/bos`} component={CommonBOS} />
        <Route
          path={`/${currentDomain}/research-publications`}
          component={CommonResearchPublications}
        />
        <Route path={`/${currentDomain}/mous-signed`} component={MousSigned} />
        <Route
          path={`/${currentDomain}/internship-opportunities`}
          component={InternshipOpportunities}
        />
        <Route
          path={`/${currentDomain}/campus-placements`}
          component={CampusPlacements}
        />
        <Route
          path={`/${currentDomain}/eligibility`}
          component={CommonEligibility}
        />
        <Route
          path={`/${currentDomain}/contact-us`}
          component={CommonContact}
        />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );
  if (currentDomain === "ssit")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route
          path={`/${currentDomain}/about-course`}
          component={CommonAboutCourse}
        />
        <Route
          path={`/${currentDomain}/vision-and-mission`}
          component={VisionAndMission}
        />
        <Route
          path={`/${currentDomain}/academic-calendar`}
          component={AcademicCalendar}
        />
        <Route path={`/${currentDomain}/timetables`} component={Timetables} />
        <Route
          path={`/${currentDomain}/case-study-focus`}
          component={CaseStudyFocus}
        />
        <Route
          path={`/${currentDomain}/ssit-advantage`}
          component={SSITAdvantage}
        />
        <Route
          path={`/${currentDomain}/course-structure`}
          component={CommonCourseStructure}
        />
        <Route
          path={`/${currentDomain}/infra-structure`}
          component={CommonInfrastructure}
        />
        <Route path={`/${currentDomain}/syllabus`} component={CommonSyllabus} />
        <Route path={`/${currentDomain}/faculty`} component={CommonFaculty} />
        <Route path={`/${currentDomain}/bos`} component={CommonBOS} />
        <Route
          path={`/${currentDomain}/research-scholars`}
          component={ResearchScholars}
        />
        <Route
          path={`/${currentDomain}/research-publications`}
          component={ResearchPublications}
        />
        <Route
          path={`/${currentDomain}/eligibility`}
          component={CommonEligibility}
        />
        <Route
          path={`/${currentDomain}/contact-us`}
          component={CommonContact}
        />
        <Route
          path={`/${currentDomain}/workshop-conference`}
          component={WorkshopConference}
        />
          <Route
          path={`/${currentDomain}/downloads`}
          component={Downloads}
        />
          <Route path={`/${currentDomain}/gallery`} component={SSITGallery} />
        <Route path={`/${currentDomain}/about-us`} component={CommonAbout} />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );
  if (currentDomain === "snt")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route
          path={`/${currentDomain}/about-course`}
          component={CommonAboutCourse}
        />
        <Route
          path={`/${currentDomain}/academic-calendar`}
          component={AcademicCalenders}
        />
        <Route
          path={`/${currentDomain}/timetables`}
          component={SNTTimetables}
        />
        <Route
          path={`/${currentDomain}/industry-interaction`}
          component={IndustryInteraction}
        />
        <Route
          path={`/${currentDomain}/course-structure`}
          component={CommonCourseStructure}
        />
        <Route
          path={`/${currentDomain}/infra-structure`}
          component={CommonInfrastructure}
        />
        <Route path={`/${currentDomain}/syllabus`} component={CommonSyllabus} />
        <Route path={`/${currentDomain}/faculty`} component={CommonFaculty} />
        <Route path={`/${currentDomain}/bos`} component={CommonBOS} />
        <Route
          path={`/${currentDomain}/research-scholars`}
          component={ResearchScholars}
        />
        <Route
          path={`/${currentDomain}/research-publications`}
          component={CommonResearchPublications}
        />
        <Route
          path={`/${currentDomain}/project-opportunities`}
          component={ProjectOpportunities}
        />
        <Route
          path={`/${currentDomain}/campus-placements`}
          component={SNTCampusPlacements}
        />
        <Route
          path={`/${currentDomain}/notificationstenders`}
          component={NotificationsTenders}
        />
        <Route
          path={`/${currentDomain}/sports-activity`}
          component={SportsActivity}
        />
        <Route
          path={`/${currentDomain}/achievements`}
          component={SNTAchievements}
        />
        <Route
          path={`/${currentDomain}/student-activities`}
          component={StudentActivities}
        />
        <Route path={`/${currentDomain}/gallery`} component={CommonGallery} />
        <Route
          path={`/${currentDomain}/eligibility`}
          component={CommonEligibility}
        />
        <Route
          path={`/${currentDomain}/contact-us`}
          component={CommonContact}
        />
        <Route path={`/${currentDomain}/about-us`} component={CommonAbout} />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );
  if (currentDomain === "sms")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route
          exact
          path={`/${currentDomain}/about-course`}
          component={CommonAboutCourse}
        />
        <Route path={`/${currentDomain}/programs`} component={Programs} />
        <Route
          path={`/${currentDomain}/academic-calendar`}
          component={AcademicCalendar}
        />
        <Route
          path={`/${currentDomain}/course-structure`}
          component={CommonCourseStructure}
        />
        <Route
          path={`/${currentDomain}/infra-structure`}
          component={CommonInfrastructure}
        />
        <Route path={`/${currentDomain}/syllabus`} component={CommonSyllabus} />
        <Route path={`/${currentDomain}/faculty`} component={CommonFaculty} />
        <Route
          path={`/${currentDomain}/notifications`}
          component={SMSNotifications}
        />
        <Route
          path={`/${currentDomain}/placements`}
          component={SMSPlacements}
        />
        <Route
          path={`/${currentDomain}/achivements`}
          component={SMSAchivements}
        />
        <Route
          path={`/${currentDomain}/research-publications`}
          component={CommonResearchPublications}
        />
        <Route path={`/${currentDomain}/alumni`} component={Alumni} />
        <Route
          path={`/${currentDomain}/forthcoming-events`}
          component={ForthcomingEvents}
        />
        <Route path={`/${currentDomain}/past-events`} component={PastEvents} />
        <Route path={`/${currentDomain}/gallery`} component={CommonGallery} />
        <Route
          path={`/${currentDomain}/eligibility`}
          component={CommonEligibility}
        />
        <Route
          path={`/${currentDomain}/contact-us`}
          component={CommonContact}
        />
        <Route path={`/${currentDomain}/about-us`} component={CommonAbout} />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );

  if (currentDomain === "sopst")
    return (
      <Switch>
        <Route path={`/${currentDomain}/`} exact component={CommonHome} />
        <Route path={`/${currentDomain}/profile`} component={Profile} />
        <Route component={Error} />
      </Switch>
    );
};
export default App;
